import React from 'react';
import { TouchableOpacity, View, StyleSheet } from 'react-native';
import Icon from '../Icon/Icon';
import { colorPalette } from '@shared/config/colorsConfig';

export interface CustomCheckboxProps {
  checked: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  size?: number;
  checkedColor?: string;
}

export const CustomCheckbox: React.FC<CustomCheckboxProps> = ({
  checked,
  onChange,
  disabled = false,
  size = 24,
  checkedColor = colorPalette.secondary[600],
}) => {
  const handlePress = () => {
    if (!disabled && onChange) {
      onChange(!checked);
    }
  };

  return (
    
    <TouchableOpacity
      onPress={handlePress}
      disabled={disabled}
      activeOpacity={0.7}
      style={[
        styles.container,
        {
          width: size,
          height: size,
          borderRadius: size * 0.2,
        },
        checked
          ? {
              backgroundColor: checkedColor,
              borderColor: checkedColor,
            }
          : {
              backgroundColor: colorPalette.white,
              borderColor: colorPalette.gray[300],
            },
        disabled && styles.disabled,
      ]}
    >
      {checked && (
        <View style={styles.iconContainer}>
          <Icon
            name="check"
            size={size * 0.65}
            color={colorPalette.white}
          />
        </View>
      )}
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 2,
  },
  iconContainer: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  disabled: {
    opacity: 0.5,
  },
});

export default CustomCheckbox;
